import { createSelector } from 'reselect'

/**
 * Select the routes state slice
 * @param {object} state - Redux state
 * @returns {object} Routes state
 */
export const selectRoutesState = (state) => state.routes

/**
 * Select the current path
 * @param {object} state - Redux state
 * @returns {string} Current path
 */
export const selectCurrentPath = createSelector(
  selectRoutesState,
  (routes) => routes.currentPath
)

/**
 * Select the navigation tabs
 * @param {object} state - Redux state
 * @returns {Array} Tabs
 */
export const selectTabs = createSelector(
  selectRoutesState,
  (routes) => routes.tabs
)

/**
 * Select all route definitions
 * @param {object} state - Redux state
 * @returns {Array} Route definitions
 */
export const selectRoutes = createSelector(
  selectRoutesState,
  (routes) => routes.routes
)

/**
 * Select the current route by matching the current path
 * @param {object} state - Redux state
 * @returns {object|undefined} Current route definition
 */
export const selectCurrentRoute = createSelector(
  selectRoutes,
  selectCurrentPath,
  (routes, currentPath) => routes.find(({ path }) => path === currentPath)
)
